export const IBAN_LABEL = 'IBAN';
export const ACCOUNT_HOLDER_LABEL = 'Kontoinhaber';
export const BIC_LABEL = 'BIC / SWIFT';
export const ACCOUNT_NUMBER_LABEL = 'Kontonummer';
export const BLZ_LABEL = 'Bankleitzahl';
export const BANK_NAME_LABEL = 'Bankname';
export const MANDATE_REFERENCE_NUMBER_LABEL = 'Mandatsreferenznummer';
export const MANDATE_REFERENCE_DATE_LABEL = 'Mandat erteilt am';
export const OK_LABEL = 'Übernehmen';
export const CANCEL_LABEL = 'Abbrechen';
export const NEW_ADDRESS_LABEL = 'Neue Adresse';
export const NEW_CONTACT_LABEL = 'Neuer Kontakt';
export const FROM_CONTACT_BOOK_LABEL = 'Aus Adressbuch';
export const ADD_NEW_ADDRESS_LABEL = 'Neue Adresse hinzufügen';
export const ADDRESS_TAB_LABEL = 'Adresse';
export const BANK_TAB_LABEL = 'Bank';
export const ID_TAB_LABEL = 'IDs';
export const LOGO_TAB_LABEL = 'Logo';
export const SAVE_LABEL = 'Speichern';
export const DELETE_LOGO_LABEL = 'Logo löschen';
export const DELETE_LOGO_TEXT_LABEL = 'Wollen sie das Logo löschen?';
export const UPLOAD_LOGO_LABEL = 'Logo hochladen';
export const VALUE_LABEL = 'Wert';
export const CUSTOMER_REFERENCE_LABEL = 'Kundenreferenz';
export const LID_LABEL = 'LID';
export const DEBTOR_LABEL = 'Debitor';
export const ADD_REGISTRATION_LABEL = 'Neue Registrierung hinzufügen';
export const APPOINTMENT_LABEL = 'Termin';
export const TASK_LABEL = 'Auftrag';
export const OFFER_LABEL = 'Angebot';
export const INVOICE_LABEL = 'Rechnung';
export const CONTACT_PAGE_TITLE_LABEL = 'Kontakte';
export const CONTACT_PAGE_SUBTITLE_LABEL = 'Alle Kontakte auf einen Blick';
export const DELETE_CONTACT_LABEL = 'Kontakt löschen';
export const DELETE_CONTACT_TEXT_LABEL = 'Wollen Sie den Kontakt wirklich löschen?';
